import { css } from '@emotion/css';
import { cssVarV2 } from '@toeverything/theme/v2';

import { LEFT_TOOL_BAR_WIDTH } from '../consts.js';

export const tableView = css({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
});

export const tableContainer = css({
  overflowY: 'auto',
});

export const tableBlockTable = css({
  position: 'relative',
  width: '100%',
  paddingBottom: '4px',
  zIndex: 1,
  overflowX: 'scroll',
  overflowY: 'hidden',
  '&::-webkit-scrollbar': {
    height: '8px',
  },
  '&::-webkit-scrollbar-thumb:horizontal': {
    borderRadius: '4px',
    backgroundColor: 'transparent',
  },
  '&::-webkit-scrollbar-track:horizontal': {
    backgroundColor: 'transparent',
    height: '8px',
  },
  '&:hover::-webkit-scrollbar-thumb:horizontal': {
    borderRadius: '4px',
    backgroundColor: 'var(--affine-black-30)',
  },
  '&:hover::-webkit-scrollbar-track:horizontal': {
    backgroundColor: 'var(--affine-hover-color)',
    height: '8px',
  },
});

export const tableContainer2 = css({
  position: 'relative',
  width: 'fit-content',
  minWidth: '100%',
});

// Hide the native horizontal scrollbar on the table scroll area when the
// sticky proxy scrollbar is active, so there is only one bar.
export const hideNativeXScrollbar = css({
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
});

// A sticky proxy scrollbar that mirrors the horizontal scroll of the table.
// It sticks to the bottom of the viewport while the table is on screen, so the
// user does not have to scroll to the very bottom of a tall table to reach the
// native horizontal scrollbar.
export const stickyScrollbar = css({
  position: 'sticky',
  bottom: '0',
  left: '0',
  zIndex: 2,
  overflowX: 'auto',
  overflowY: 'hidden',
  height: '12px',
  display: 'none',
  '&[data-enabled="true"][data-visible="true"]': {
    display: 'block',
  },
  '&::-webkit-scrollbar': {
    height: '8px',
  },
  '&::-webkit-scrollbar-thumb:horizontal': {
    borderRadius: '4px',
    backgroundColor: 'var(--affine-black-30)',
  },
  '&::-webkit-scrollbar-track:horizontal': {
    backgroundColor: 'var(--affine-hover-color)',
    height: '8px',
  },
});

export const stickyScrollbarInner = css({
  height: '1px',
});

export const globalStatsBar = css({
  display: 'flex',
  width: 'fit-content',
  minWidth: '100%',
  borderTop: `1px solid ${cssVarV2.database.border}`,
  backgroundColor: cssVarV2.layer.background.primary,
});

export const addGroup = css({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  padding: '6px 12px 6px 8px',
  color: cssVarV2.text.secondary,
  fontSize: '12px',
  lineHeight: '20px',
  position: 'sticky',
  left: `${LEFT_TOOL_BAR_WIDTH}px`,
});
